import { createAction } from "@reduxjs/toolkit";


export const undisplaySwipeableDrawerSummary = createAction("swipeableDrawerSummary/UndisplaySwipeableDrawerSummary")
export const displaySwipeableDrawerSummaryCandidat = createAction("swipeableDrawerSummary/displaySwipeableDrawerSummaryCandidat")
export const displaySwipeableDrawerSummaryContact = createAction("swipeableDrawerSummary/displaySwipeableDrawerSummaryContact")
export const displaySwipeableDrawerSummarySociete = createAction("swipeableDrawerSummary/displaySwipeableDrawerSummarySociete")